import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

import RecipientColumn from '../../../components/columns/recipient-column';
import { ResidentialIndicator } from '../../../enums/residential-indicator';
import { messages } from './messages';

const RecipientComponent = ({ fulfillmentPlanId, salesOrderId }) => {
  const { labelConfiguration, externalFulfillmentConfiguration, international } = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId }),
  );
  const soldTo = useSelector((state) =>
    Global.selectEntitiesSalesOrderProperty(state, {
      salesOrderId,
      property: 'soldTo',
    }),
  );

  const { customerId } = soldTo ?? {};

  const { isInternational = false } = international ?? {};
  const { name, residentialIndicator, verificationStatus, countryCode, verificationMessage } =
    labelConfiguration?.shipTo ?? externalFulfillmentConfiguration?.shipTo ?? {};

  return (
    <RecipientColumn
      customerId={customerId}
      destinationCountryCode={countryCode}
      isDomestic={!isInternational}
      recipientName={name}
      residentialIndicator={residentialIndicator ?? ResidentialIndicator.Commercial}
      verificationMessage={verificationMessage}
      verificationStatus={verificationStatus}
    />
  );
};

RecipientComponent.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  salesOrderId: PropTypes.string.isRequired,
};

export const Recipient = {
  getMessageDescriptor: () => messages.recipient,
  id: 'recipient',

  render: (data, { isFirstRow = true } = {}) => {
    if (!isFirstRow) {
      return null;
    }

    return <RecipientComponent fulfillmentPlanId={data.id} salesOrderId={data.salesOrderId} />;
  },
};
